import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaWesele = () => (
  <SeoPageLayout title="Kabaret na wesele - oryginalna atrakcja weselna">
    <p>
      Szukasz wyjątkowej atrakcji na wesele, która zaskoczy gości i sprawi, że Twoje przyjęcie weselne będzie inne niż wszystkie? Kabaret na wesele to coraz popularniejszy wybór par młodych, które chcą zapewnić swoim gościom niezapomnianą rozrywkę.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret weselny - nowoczesna alternatywa dla tradycyjnych atrakcji</h2>
    <p>
      Tradycyjne zabawy weselne odchodzą powoli do lamusa. Współczesne pary szukają oryginalnych form rozrywki, które bawią wszystkich gości - od najmłodszych po seniorów. Kabaret na weselu to profesjonalna rozrywka na najwyższym poziomie, dopasowana do charakteru uroczystości.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kiedy najlepiej zaplanować występ kabaretowy na weselu?</h2>
    <p>
      Optymalny moment na występ kabaretowy to przerwa między daniami lub czas po torcie weselnym. Występ trwa zazwyczaj od 30 do 60 minut - wystarczająco długo, by rozbawić gości, ale nie na tyle, by zdominować resztę programu.
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>Po obiedzie weselnym - jako przerywnik przed zabawą taneczną</li>
      <li>Między daniami - wypełnia naturalną przerwę w programie</li>
      <li>Po torcie - jako kulminacyjny punkt rozrywki wieczoru</li>
      <li>Jako niespodzianka - zorganizowana w tajemnicy przed parą młodą lub gośćmi</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Jakie tematy porusza kabaret weselny?</h2>
    <p>
      Profesjonalny kabaret weselny bazuje na uniwersalnym humorze dotyczącym relacji, małżeństwa, rodziny i codziennego życia. Materiał jest zawsze elegancki i stosowny - unikamy wulgarności i kontrowersyjnych tematów. Na życzenie przygotowujemy personalizowane skecze nawiązujące do historii pary młodej.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na wesele - dla kogo?</h2>
    <p>
      Kabaret weselny sprawdzi się na każdym weselu - zarówno dużym, kilkusetosobowym przyjęciu, jak i kameralnej uroczystości w gronie najbliższych. Artyści dopasowują formę i energię występu do wielkości sali i liczby gości.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Jak zamówić kabaret na wesele?</h2>
    <p>
      Terminy weselne rezerwujemy z wyprzedzeniem - zalecamy kontakt co najmniej 3 miesiące przed planowaną datą wesela. Wypełnij formularz kontaktowy lub zadzwoń, a przygotujemy ofertę dopasowaną do Twojego wesela.
    </p>
  </SeoPageLayout>
);

export default KabaretNaWesele;
